export const Images = {
  APPLE_STORE: require('./apple-store.svg').default as '',
  LOGO: require('./logo.svg').default as '',
  RECCO_BANNER: require('./recco-banner.png') as '',
  LOADER: require('./loader.gif') as '',
  GIVE_RECCO_BANNER_MOBI: require('./give-recco-banner-mobi.svg').default as '',
  GIVE_RECCO_BANNER: require('./give-recco-banner.svg').default as '',
  GIFT: require('./gift.svg').default as '',
  SHARE_RECCO_BANNER: require('./share-recco-banner.svg').default as '',
  RECCO_PLACEHOLDER: require('./recco_placeholder.svg').default as '',
  PLACEHOLDER_NOT_FOUND: require('./placeholder.svg').default as '',
  PLACEHOLDER_404: require('./404.svg').default as '',
  PLAY_STORE: require('./play-store.svg').default as '',
  ARROW_WHITE: require('./arrow.svg').default as '',
  BLUE_TICK: require('./blue-tick.svg').default as '',
  FILE_UPLOAD_BACKDROP_IMAGE: require('./file-upload-backdrop-image.png').default as '',
  GROUP_IMAGE: require('./group.svg').default as '',
  NO_ACTIVITY: require('./no-activity.svg').default as '',
  SKELETON_BUBBLES: require('./skeleton-bubbles.svg').default as '',
  SEARCH_CANDIDATE_CARD: require('./search-candidate-card.svg').default as '',
  CREATE_OPPORTUNITY_CARD: require('./create-opportunity-card.svg').default as '',
  SEMANTIC_SEARCH_NO_DATA: require('./Semantic-search-no-data.svg').default as '',
};
